<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none" viewBox="0 0 15 15">
  <g clip-path="url(#a)">
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M9.914 1.24v2.478M4.957 1.239v2.479M1.86 6.196h11.153M3.098 2.48h8.675c.685 0 1.24.554 1.24 1.239v8.675a1.24 1.24 0 0 1-1.24 1.24H3.098a1.24 1.24 0 0 1-1.24-1.24V3.718c0-.685.556-1.24 1.24-1.24Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path fill="#fff" d="M0 0h14.871v14.871H0z"/>
    </clipPath>
  </defs>
</svg>
